exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-5e9d2adc] {\n  font-size: 20px;\n  font-weight: 500;\n  color: #777;\n}\n.variants-holder[data-v-5e9d2adc] {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n.variants-holder input[data-v-5e9d2adc] {\n  display: inline-block;\n  width: auto;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  min-width: 50px;\n  color: inherit;\n}\n.table.fields td[data-v-5e9d2adc] {\n  vertical-align: middle;\n}\n.actions[data-v-5e9d2adc] {\n  display: flex;\n  justify-content: flex-end;\n  gap: 20px;\n  margin-top: 20px;\n}", ""]);

// exports
